<template>
  <v-container>
    <page-title title="Live feed" class="d-none"></page-title>

<p class="sub-hero-text">Coming soon ...</p>
    <!---------posts---------->
    <v-card
      class="mt-4 mb-8 d-none"
      v-for="post in posts"
      :key="post.id"
      elevation="2"
      style="cursor: pointer"
      @click="goToPost(post.id)"
    >
      <v-card-title primary-title class="d-flex justify-space-between">
        <div>
          <v-avatar size="35" color="var(--white)">
            <img
              src="@/assets/illustration/user.png"
              :alt="firstname + ' ' + lastname"
              v-if="!post.profile_picture_url"
              class="no-profile-picture"
            />
            <img
              :src="profile_picture_url"
              :alt="firstname + ' ' + lastname"
              v-else
            />
          </v-avatar>
          <small class="px-2 user-name">{{ post.user }}</small>
        </div>
        <time-ago :datetime="post.date" :refresh="60" long />
      </v-card-title>
      <div three-line>
        <v-card-text class="px-7 py-5">
          {{ post.post }}
        </v-card-text>
      </div>
      <v-card-actions class="px-4">
        <v-btn text small outlined
          ><v-icon small class="px-1"> mdi-eye-outline </v-icon>
          <!---------if post is more than 1000 show it with K multiplier and M if up to a million-------->
          {{
            post.watchers >= 1000000
              ? (post.watchers / 1000000).toFixed(1) + "M"
              : post.watchers >= 1000
              ? (post.watchers / 1000).toFixed(1) + "k"
              : post.watchers
          }}
        </v-btn>
        <v-btn text small outlined
          ><v-icon small class="px-1">mdi-comment-outline </v-icon>
          {{
            post.comments >= 1000000
              ? (post.comments / 1000000).toFixed(1) + "M"
              : post.comments >= 1000
              ? (post.comments / 1000).toFixed(1) + "k"
              : post.comments
          }}
        </v-btn>
        <v-btn text small outlined
          ><v-icon small class="px-1"> mdi-heart-outline</v-icon>
          {{
            post.likes >= 1000000
              ? (post.likes / 1000000).toFixed(1) + "M"
              : post.likes >= 1000
              ? (post.likes / 1000).toFixed(1) + "k"
              : post.likes
          }}
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-btn fab color="var(--purple)" right bottom fixed style="bottom: 4rem">
      <v-icon color="white"> mdi-plus </v-icon>
    </v-btn>

  </v-container>
</template>

<script>
import PageTitle from "../../components/PageTitle.vue";
import store from "@/store";
import axios from "axios";

// for keeping track of time
import { TimeAgo } from "vue2-timeago";
import "vue2-timeago/dist/vue2-timeago.css";

//import method to fetch post from API and mount ot on vue "mounted" hook
export default {
  components: {
    PageTitle,
    TimeAgo,
  },

  data: () => ({
    //default bottom nav item on mobile
    // value: 0,
    active: true,
    query: "",
    drawer: null,
    page: 5,
    posts: null,
  }),

  created() {
    this.getFeedPosts();
  },

  methods: {
    //get posts form the database
    async getFeedPosts() {
      const posts = await axios.get("/forum/feed");
      this.posts = posts.data.posts;
    },

    //re route to the post form comment and
    goToPost(postId) {
      console.log(postId);
      this.$router.push({ name: "post-in-detail", params: { postId } });
    },
  },

  computed: {
    //load notification total notification  from central store when user is authenticated
    totalNotification: () => store.getters["notification/count"],
    //get user profile from central store here
    firstname: () => store.getters["auth/user"].firstname,
    lastname: () => store.getters["auth/user"].lastname,
    email: () => store.getters["auth/user"].email,
    bio: () => store.getters["auth/user"].bio,
    username: () => store.getters["auth/user"].username,
    phone: () => store.getters["auth/user"].phone,
    profile_picture_url: () => store.getters["auth/user"].profile_picture_url,
  },
};
</script>

<style scoped>
img.no-profile-picture {
  border: 1px solid rgb(177, 173, 173);
  padding: 3px;
}

small.user-name {
  font-weight: bolder;
}
</style>